
const Login = resolve => {
    require(['./views/Login.vue'], resolve)
};
const SettleLogin = resolve => {
    require(['./views/settleLogin.vue'], resolve)
};
const MaintainReport = resolve => {
    require(['./views/maintainReport.vue'], resolve)
};
const settleCheckReport = resolve => {
    require(['./views/settle-checkReport.vue'], resolve)
};
const Index = resolve => {
    require(['./views/index.vue'], resolve)
};
//import Index from './views/index'//首页
const MyCenter = resolve => {
    require(['./views/myCenter.vue'], resolve)
};
//import MyCenter from './views/myCenter'//个人中心
const ChoseCar = resolve => {
    require(['./views/choseCar.vue'], resolve)
};
//import ChoseCar from './views/choseCar'//选择车辆
const serviceDetail = resolve => {
    require(['./views/serviceDetail.vue'], resolve)
};
//import serviceDetail from './views/serviceDetail'//服务详情
const serviceShow = resolve => {
    require(['./views/serviceShow.vue'], resolve)
};
//import serviceShow from './views/serviceShow'//服务展示
const carDetail = resolve => {
    require(['./views/carDetail.vue'], resolve)
};
//import carDetail from './views/carDetail'//车辆详情
const searchPage = resolve => {
    require(['./views/search.vue'], resolve)
};
//import searchPage from './views/search' //搜索

const confirmOrder = resolve => {
    require(['./views/confirmOrder.vue'], resolve)
};
//import confirmOrder from './views/confirmOrder' //确认订单

const ordered = resolve => {
    require(['./views/ordered.vue'], resolve)
};

//import ordered from './views/ordered' //预约订单
const addAddress = resolve => {
    require(['./views/addAddress.vue'], resolve)
};

//import addAddress from './views/addAddress' //添加地址
const addressList = resolve => {
    require(['./views/addressList.vue'], resolve)
};
//import addressList from './views/addressList';//地址列表

const findNoCar = resolve => {
    require(['./views/findNoCar.vue'], resolve)
};
//import findNoCar from './views/findNoCar' //没有找到车辆

const storeList = resolve => {
    require(['./views/storeList.vue'], resolve)
};
//import storeList from './views/storeList' //门店列表

const myOrder = resolve => {
    require(['./views/myOrder.vue'], resolve)
};
//import myOrder from './views/myOrder'//我的订单

const orderDetail = resolve => {
    require(['./views/orderDetail.vue'], resolve)
};
//import orderDetail from './views/orderDetail'//订单详情

const orderProcess = resolve => {
    require(['./views/orderProcess.vue'], resolve)
};
//import orderProcess from './views/orderProcess' //订单进程

const upkeepReport = resolve => {
    require(['./views/upkeepReport.vue'], resolve)
};
//import upkeepReport from './views/upkeepReport' //保养报告

const myCarCenter = resolve => {
    require(['./views/myCarCenter.vue'], resolve)
};
//import myCarCenter from './views/myCarCenter' //我的车辆

const orderEval = resolve => {
    require(['./views/orderEval.vue'], resolve)
};
//import orderEval from './views/orderEval'//订单评价

const myCarDetail = resolve => {
    require(['./views/myCarDetail.vue'], resolve)
};
//import myCarDetail from './views/myCarDetail'//我的爱车

const showComment = resolve => {
    require(['./views/showComment.vue'], resolve)
};
//import showComment from './views/showComment' //晒单

const mySetting = resolve => {
    require(['./views/mySetting.vue'], resolve)
};
//import mySetting from './views/mySetting'//个人设置

const messageCenter = resolve => {
    require(['./views/messageCenter.vue'], resolve)
};
//import messageCenter from './views/messageCenter' //消息中心

const Help = resolve => {
    require(['./views/Help.vue'], resolve)
};
//import Help from './views/Help' //帮助中心

const upkeepHandBook = resolve => {
    require(['./views/upkeepHandBook.vue'], resolve)
};
//import upkeepHandBook from './views/upkeepHandBook'//保养手册和原厂配件

const upkeepRecord = resolve => {
    require(['./views/upkeepRecord.vue'], resolve)
};
//import upkeepRecord from './views/upkeepRecord' //保养记录

const checkReport = resolve => {
    require(['./views/checkReport.vue'], resolve)
};
//import upkeepRecord from './views/upkeepRecord' //检测报告

const addUpkeepRecord = resolve => {
    require(['./views/addUpkeepRecord.vue'], resolve)
};
//import addUpkeepRecord from './views/addUpkeepRecord'//添加保养记录

const remindSetting = resolve => {
    require(['./views/remindSetting.vue'], resolve)
};
//import remindSetting from './views/remindSetting' //提醒设置

const activityList = resolve => {
    require(['./views/activityList.vue'], resolve)
};
//import activityList from './views/activityList' //活动列表

const activityDetail = resolve => {
    require(['./views/activityDetail.vue'], resolve)
};
//import activityDetail from './views/activityDetail' //活动详情*/

const makeOutBill = resolve => {
    require(['./views/makeOutBill.vue'], resolve)
};
//import makeOutBill from './views/makeOutBill' //开具发票

const showCoupons = resolve => {
    require(['./views/showCoupons.vue'], resolve)
};
//import showCoupons from './views/showCoupons' //显示优惠券

const feedBack = resolve => {
    require(['./views/feedBack.vue'], resolve)
};
//import feedBack from './views/feedBack' //意见反馈

const mapAreaLimit = resolve => {
    require(['./views/mapAreaLimit.vue'], resolve)
};
//import mapAreaLimit from './views/mapAreaLimit' //查看服务区域

const helpList = resolve => {
    require(['./views/helpList.vue'], resolve)
};
//import helpList from './views/helpList' //帮助列表

const moreServices = resolve => {
    require(['./views/moreServices.vue'], resolve)
};
//import moreServices from './views/moreServices'//更多服务

const datePicker = resolve => {
    require(['./views/datePicker.vue'], resolve)
};

const aboutUs = resolve => {
    require(['./views/aboutUs.vue'], resolve)
}

// 龙珠保单验证页面
const longzhuVerify = resolve => {
    require(['./views/longzhuVerify.vue'], resolve)
}

// ?token=***/#/ym/introduce 北京人保-亿美-卡拉丁对接 亿美跳入首页
const ymIntroduce = resolve => {
    require(['./views/ymIntroduce.vue'], resolve)
}
// 北京人保-亿美-卡拉丁对接 亿美确认充值
const ymCharge = resolve => {
    require(['./views/ymCharge.vue'], resolve)
}

// 北京人保-亿美-卡拉丁对接 亿美充值成功
const ymChargeSuccess = resolve => {
    require(['./views/ymChargeSuccess.vue'], resolve)
}
// 无锡人保
const wxInsurance = resolve => {
    require(['./views/wxInsurance.vue'], resolve)
}

const scanChooseCar = resolve => {
    require(['./views/scanChooseCar.vue'], resolve)
}
// 中华联合
const thirdLogin = resolve => {
    require(['./views/thirdLogin.vue'], resolve)
}
const thirdRights = resolve => {
    require(['./views/thirdRights.vue'], resolve)
}
const thirdActivityDetail = resolve => {
    require(['./views/thirdActivityDetail.vue'], resolve)
}
const choseCarInsurer = resolve => {
    require(['./views/choseCarInsurer.vue'], resolve)
}

const carDetailInsurer = resolve => {
    require(['./views/carDetailInsurer.vue'], resolve)
};

const insurerService = resolve => {
    require(['./views/insurerService.vue'], resolve)
};
/*
 * 问题列表
 */
const answer1 = resolve => {
    require(['./components/answer/answer1.vue'], resolve)
}
const answer2 = resolve => {
    require(['./components/answer/answer2.vue'], resolve)
}
const answer3 = resolve => {
    require(['./components/answer/answer3.vue'], resolve)
}
const answer4 = resolve => {
    require(['./components/answer/answer4.vue'], resolve)
}
const answer5 = resolve => {
    require(['./components/answer/answer5.vue'], resolve)
}
const answer6 = resolve => {
    require(['./components/answer/answer6.vue'], resolve)
}
const answer7 = resolve => {
    require(['./components/answer/answer7.vue'], resolve)
}
const answer8 = resolve => {
    require(['./components/answer/answer8.vue'], resolve)
}
const answer1List = resolve => {
    require(['./components/answer/answer1List.vue'], resolve)
}
const answer2List = resolve => {
    require(['./components/answer/answer2List.vue'], resolve)
}

//import datePicker from './views/datePicker'
/*
 * 需要登录 拦截 requireAuth 为ture
 * 需要城市 拦截 requireCity 为ture
 * 需要车型 拦截 requireCar  为true
 */
let routes = [
    {
        path: '/',
        redirect: '/index'
    },

    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/maintain-report',
        component: MaintainReport,
        name: ''
    },
    {
        path: '/settle-checkReport',
        component: settleCheckReport,
        name: ''
    },
    {
        path: '/settleLogin',
        component: SettleLogin,
        name: '',
        hidden: true
    },
    {
        path: '/index',
        component: Index,
        name: ''
    },
    {
        path: '/my_center',
        component: MyCenter,
        meta: {
            requireAuth: true
        },
        name: ''

    },
    {
        path: '/autobrands',
        component: ChoseCar,
        name: ''
    },
    {
        path: '/aboutUs',
        component: aboutUs,
        name: ''
    },
    {
        path: '/introduce_micro_maintenance',
        component: serviceDetail,
        name: ''
    },
    {
        path: '/longzhu_verify',
        component: longzhuVerify,
        name: 'longzhuVerify'
    },
    {
        path: '/service_types',
        component: serviceShow,
        meta: {
            requireAuth: true,
            requireCar: true,
            requireCity: true,
            isScroll: 1
        },
        name: ''
    },
    {
        path: '/carDetail',
        component: carDetail,
        name: ''
    },
    {
        path: '/search',
        component: searchPage,
        name: ''
    },
    {
        path: '/confirmOrder',
        component: confirmOrder,
        meta: {
            requireAuth: true
        },
        name: ''
    },
    {
        path: '/orders',
        component: ordered,
        meta: {
            requireCar: true,
            requireCity: true,
            requireAuth: true
        },
        name: ''
    },
    {
        path: '/addAddress',
        component: addAddress,
        meta: {
            requireAuth: true
        },
        name: ''
    },
    {
        path: '/service_addresses',
        component: addressList,
        name: ''
    },
    {
        path: '/findNoCar',
        component: findNoCar
    },
    {
        path: '/storeList',
        component: storeList
    },
    {
        path: '/my_orders',
        component: myOrder,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/my_orders/:order_number',
        component: confirmOrder,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/orderDetail',
        component: orderDetail
    },
    {
        path: '/orderProcess',
        component: orderProcess,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/my_maintains',
        component: upkeepReport,
        meta: {
            requireAuth: true,
            keepAlive: true
        }
    },
     {
        path: '/checkReport',
        component: checkReport,
        meta: {
            requireAuth: true,
            keepAlive: true
        }
    },
    {
        path: '/my_cars',
        component: myCarCenter,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/orderEval',
        component: orderEval,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/myCarDetail',
        component: myCarDetail
    },
    {
        path: '/evaluations',
        component: showComment,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/mySetting',
        component: mySetting,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/messageCenter',
        component: messageCenter
    },
    {
        path: '/Help',
        component: Help
    },
    {
        path: '/upkeepHandBook',
        component: upkeepHandBook
    },
    {
        path: '/upkeepRecord',
        component: upkeepRecord,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/addUpkeepRecord',
        component: addUpkeepRecord
    },
    {
        path: '/remindSetting',
        component: remindSetting,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/activityList',
        component: activityList
    },
    {
        path: '/activityDetail',
        component: activityDetail
    },
    {
        path: '/invoice',
        component: makeOutBill,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/my_discounts',
        component: showCoupons,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/feedBack',
        component: feedBack,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/mapAreaLimit',
        component: mapAreaLimit
    },
    {
        path: '/helpList',
        component: helpList
    },
    {
        path: '/moreServices',
        component: moreServices
    },
    {
        path: '/datePicker',
        component: datePicker
    },
    {
        path: '/answer1',
        component: answer1
    },
    {
        path: '/answer2',
        component: answer2
    },
    {
        path: '/answer3',
        component: answer3
    },
    {
        path: '/answer4',
        component: answer4
    },
    {
        path: '/answer5',
        component: answer5
    },
    {
        path: '/answer6',
        component: answer6
    },
    {
        path: '/answer7',
        component: answer7
    },
    {
        path: '/answer8',
        component: answer8
    },
    {
        path: '/answer1List',
        component: answer1List
    },
    {
        path: '/answer2List',
        component: answer2List
    },
    {
        path: '/ym/introduce', // /?token=***/#/ym/introduce
        component: ymIntroduce
    },
    {
        path: '/ym/recharge',
        component: ymCharge
    },
    {
        path: '/ym/ymChargeSuccess',
        component: ymChargeSuccess
    },
    {
        path: '/wxInsurance',
        component: wxInsurance
    },
    {
        path: '/scanChooseCar',
        component: scanChooseCar
    },
    {
        path: '/third-login',
        component: thirdLogin
    },
    {
        path: '/third-rights',
        component: thirdRights,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/third-activity-detail',
        component: thirdActivityDetail
    },
    {
        path: '/choseCarInsurer',
        component: choseCarInsurer,
        name: ''
    },
    {
        path: '/choseCarInsurer',
        component: choseCarInsurer,
        name: ''
    },
    {
        path: '/carDetailInsurer',
        component: carDetailInsurer,
        name: ''
    }, 
    {
        path: '/insurer-service',
        component: insurerService,
        name: ''
    }
    
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js